import $ from './plugins/jquery-global';

import Cookies from 'js-cookie';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset.js';
import 'lazysizes/plugins/respimg/ls.respimg.js';
import './alpine';
import './mobileMenu';
import './plugins/dropdown.plugin';
import './plugins/trackFocus';
import './plugins/what-input';
import './reduced-motion';
import './sliders';

let reduceMotion = localStorage.getItem('reduceMotion');

$(async function () {
    $('nav.primary').dropdown();
    $('nav.secondary').dropdown();

    // modals — load magnific-popup only if the page has a modal trigger
    const $modalButtons = $('.modal__button');
    if ($modalButtons.length) {
        await import('./plugins/magnific-popup');
        $modalButtons.magnificPopup({
            type: 'inline',
            closeBtnInside: true,
            closeOnContentClick: false,

            callbacks: {
                open: function () {
                    const mp = $.magnificPopup.instance;
                    const trigger = $(mp.currItem.el[0]);

                    trigger.attr('aria-expanded', 'true');
                },

                close: function () {
                    const mp = $.magnificPopup.instance;
                    const trigger = $(mp.currItem.el[0]);

                    trigger.attr('aria-expanded', 'false');
                },
            },
        });
    }

    // quote sliders — load slick only if the page has a slider
    const $slickSliders = $('.js-slider');
    if ($slickSliders.length) {
        await import('./plugins/slick');
        $slickSliders.slick({
            arrows: true,
            dots: true,
            autoplay: reduceMotion == 'false' ? true : false,
            autoplaySpeed: 10000,
            speed: reduceMotion == 'false' ? 300 : 0,
        });
    }

    let scrollSpeed = reduceMotion == 'false' ? 500 : 0;

    var $root = $('html, body');
    $('a[href^="#"]')
        .not('.modal__button, .menu-toggle, .skip-content')
        .click(function () {
            $root.animate(
                {
                    scrollTop: $($.attr(this, 'href')).offset().top - 200,
                },
                scrollSpeed
            );
            return false;
        });

    // If we're on a different page and click a link with a hash
    if (window.location.hash) {
        $root.animate(
            {
                scrollTop: $(window.location.hash).offset().top - 200,
            },
            scrollSpeed
        );
    }
});

// Alert Ribbon
jQuery(function ($) {
    // Check if alert has been closed
    if (Cookies.get('alert-box') !== 'closed') {
        setTimeout(function () {
            $('#global_alert').slideDown();
        }, 2000);
    }
    // Handle the click event on the alert close button
    $('#global_alert .close').on('click', function (e) {
        // Do not perform default action when button is clicked
        e.preventDefault();
        Cookies.set('alert-box', 'closed', { path: '/' });
        $('#global_alert').slideUp();
    });
});

// cleanup Marketo Forms once ready.
const marketoCleanup = () => {
    // remove all but one of the #mktoStyleLoaded divs
    const marketoStyleDivs = document.querySelectorAll('#mktoStyleLoaded');
    if (marketoStyleDivs.length > 1) {
        [...marketoStyleDivs].forEach((el, index) => {
            if (index >= 1) {
                el.remove();
            }
        });
    }

    const duplicateIds = ['LblrequestedPCICertification', 'LblrequestedSOCIICertification'];

    duplicateIds.forEach((id) => {
        const elements = document.querySelectorAll(`#${id}`);
        if (elements.length > 1) {
            for (let i = 0; i < elements.length; i++) {
                elements[i].id = i === 0 ? id : `${id}-${i + 1}`;
            }
        }
    });
};

const observer = new MutationObserver(function () {
    marketoCleanup();
});

observer.observe(document, { childList: true, subtree: true });

// Enable HMR for Vite
if (import.meta.hot) {
    import.meta.hot.accept();
}
